import React , { useState, useEffect } from 'react';

 function dateFormatter( {date}){
  return ( new Intl.DateTimeFormat ('en-US' , {month : 'long' , weekday : 'long', day : 'numeric',year : 'numeric' }).format(date));
}


export default function Clock (){

const [time , setTime] = useState(new Date);
let [className , setClassName] = useState('night');

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTime(new Date);
//             setClassName( className === 'day' ?  'night' : 'day');
        }, 1000)
        return () => clearInterval(intervalId);
    })
    return (
    <>
       <h1 className={className}>
          {time.toLocaleTimeString()}
       </h1>
       <p className ="date" > {dateFormatter(time)}</p>
    </>
    );

}
